<template>
  <div class="imageList">
    <!-- <div class="imageItem imageItem--complete relative" v-for="(item, index) in list" @click="delImage(index)"> -->
    <div class="imageItem imageItem--complete relative" v-for="(item, index) in list" v-dragging="{ item: item, list: list, group: 'item' }"
          :key="index" @click="delImage(index)">
      <img :src="item" width="100" height="100">
    </div>
    <div class="imageItem relative">
      <img src="../../static/images/icon_shangchuantupian.png" width="30" height="30" class="absolute plus-btn">
      <input type="file" @change="changeImg" class="input-container pointer" style="filter:alpha(opacity=0);opacity:0" multiple>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .input-container{
    width: 100%;
    height: 100%;
  }
 .imageList{
    display: flex;
    flex-wrap: wrap;
  }
  .imageItem{
    width: 100px;
    height: 100px;
    padding: 2px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    margin: 0 20px 20px 0;
    &--complete{
      cursor: pointer;
    }
    &--complete:hover{
      &:before{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '';
        background: rgba(0,0,0,0.3);
      }
      &:after{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background: url("../../static/images/icon_del.png") no-repeat;
        width: 30px;
        height: 30px;
        background-size: 100% 100%;
        content: '';
      }
    }
  }
  .uploadImg{
    width: 106px;
    height: 106px;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .plus-btn{
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -15px;
  }
  .upload-container{
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .input-container{
    width: 100%;
    height: 100%;
  }

</style>
<script>
import util from '../script/util'
import {imageUpload} from '../api/api'
export default{
  props: {
    itype: {
      type: Number,
      default: 1
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  components: {

  },
  methods: {
    // 选择图片
    changeImg (e) {
      this.$emit('changeLoading', true)
      let $this = this
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return false
      }
      let fileList = Array.from(files)
      let list = []
      fileList.forEach(item => {
        $this.readFile(item).then(res => {
          list.push(res)
          this.list.push(res.url)
          if (list.length === fileList.length) {
            // let data = {
            //   list: list
            // }
            $this.$emit('uploadMultipleSuccess', this.list)
            this.$emit('changeLoading', false)
          }
        })
      })
      e.target.value = '' // 清空input内图片
    },
    // 转换图片为base64
    readFile (file) {
      let $this = this
      return new Promise((resolve, reject) => {
        let imagefile = file.type
        let reader = new FileReader()
        let match = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif']
        let base64 = ''
        // 判断文件类型
        if (!((imagefile === match[0]) || (imagefile === match[1]) || (imagefile === match[2]) || (imagefile === match[3]))) {
          this.notifyError('请选择正确的图片类型')
        }

        reader.onload = function (e) {
          base64 = this.result
          $this.uploadHeadimg(base64).then(url => {
            let obj = {
              name: file.name,
              url: url
            }
            resolve(obj)
          })
        }
        reader.readAsDataURL(file)
      })
    },
    // 上传图片
    uploadHeadimg (base64) {
      return new Promise((resolve, reject) => {
        let params = {
          icon_str: base64
        }
        if (this.itype !== '') {
          params.itype = this.itype
        }

        imageUpload(params).then((res) => {
          let data = res.data || {c: -1}
          if (!data.c) {
            resolve(data.d.url)
          } else {
            this.notifyError('错误码：' + data.c + ',' + util.getErrorMsg(data.c))
            resolve()
          }
        }).catch(() => {
          this.notifyError('服务器大脑短路啦')
          resolve()
        })
      })
    },
    delImage (index) {
      this.list.splice(index, 1)
      this.$emit('uploadMultipleSuccess', this.list)
    },
    // 失败提示
    notifyError (str) {
      this.$notify({
        title: '失败',
        message: str,
        type: 'error'
      })
    },
    // 成功
    notifySuccess (str) {
      this.$notify({
        title: '成功',
        message: str,
        type: 'success'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/uploadMultipleImageList.vue